import { injectIntl } from 'react-intl';
import ThankYouEsign from './ThankYouEsign';
import config from './config';

export const CONFIG = config;

export default injectIntl(ThankYouEsign);
